import React, { useEffect, useState, useRef } from "react";
import cn from "classnames";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import "./three.scss";
import "./threeFix.scss";

import Header from "../../components/header";
import Footer from "../../components/footer";

// import FirstScreen from './components/firstScreen'

function Three(props) {
  const { setCurrentDate, anchor } = props;

  const [load, setLoad] = useState(false);
  const [go, setGo] = useState(true);

  useEffect(() => {
    if (load) {
      // gsap.set('.timeline__items', { perspective: 200, autoAlpha: 1})

      // let wrapHeight = document.querySelector('.timeline').clientHeight;
      let sections = gsap.utils.toArray(".item");
      // console.log('sections: ', sections);
      // console.log('wrapHeight: ', wrapHeight);

      // const durationOpacity = 2000;

      let mob = window.screen.width > 767 ? false : true;

      let fs = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".timeline__fs",
            // start: "top",
            // end: "bottom to
            scrub: 1,
            pin: true,

            // end: '+=' + wrapHeight * sections.length,
            end: "+=" + 70500,
            onEnter: (self) => {
              console.log("1111");
              // self.scroll(500);
            },
            onLeave: (self) => {
              console.log("2222");
              // fs.pause();
            },
            onEnterBack: (self) => {
              console.log("0000");
              // fs.restart();

              let years = document.querySelector(".timeline__years");
              // years.style.opacity = 0;
              console.log("years: ", years);
            },
            onLeaveBack: (self) => {
              console.log("0000222");
            },
          },
        })

        // // screen 1
        // .to('.timeline__header--part-1', 1, { opacity: 1 }, 0)
        // .fromTo('.item__today-1',2000, { z: -2000 }, { z: !mob ? 300 : 200 }, 0)
        // .fromTo('.item__today-1', 200, { opacity: 1 }, { opacity: 1 }, "<")
        // .to('.item__today-1', 200, { opacity: 0 }, 1800)

        // .fromTo('.item__today-2', 2500, { z: -2000 }, { z: !mob ? 300 : 200 }, "<")
        // .fromTo('.item__today-2', 200, { opacity: 1 }, { opacity: 1 },"<")
        // .to('.item__today-2', 200, { opacity: 0 }, 1500)

        // .fromTo('.item__today-3', 4000, { z: -2500 }, { z:  !mob ? 300 : 0 }, 0)
        // .fromTo('.item__today-3', 200, { opacity: 1 }, { opacity: 1 }, 0)
        // .to('.item__today-3', 200, { opacity: 0 }, 3100)

        // .fromTo('.item__today-4', 3000, { z: -2000 }, { z: 300 }, 0)
        // .fromTo('.item__today-4', 200, { opacity: 1 }, { opacity: 1 }, 0)
        // .to('.item__today-4', 200, { opacity: 0 }, 2600)

        // .fromTo('.item__today-5', 6000, { z: -2000 }, { z: 500 }, 0)
        // .fromTo('.item__today-5', 200, { opacity: 1 }, { opacity: 1 }, 0)
        // .to('.item__today-5', 200, { opacity: 0 }, 3500)

        // .fromTo('.item__today-6', 8000, { z: -3000 }, { z: 300 }, 3200)
        // .fromTo('.item__today-6', 200, { opacity: 0 }, { opacity: 1 }, 3200)
        // .to('.item__today-6', 200, { opacity: 0 }, 9200)

        // .fromTo('.item__today-7', 7000, { z: -3000 }, { z: 300 }, 1500)
        // .fromTo('.item__today-7', 200, { opacity: 0 }, { opacity: 1 }, 1500)
        // .to('.item__today-7', 200, { opacity: 0 }, 6600)

        // .fromTo('.item__today-8', 6000, { z: -2000 }, { z: 300 }, 800)
        // .fromTo('.item__today-8', 200, { opacity: 0 }, { opacity: 1 }, 800)
        // .to('.item__today-8', 200, { opacity: 0 }, 5000)

        // .fromTo('.item__today-9', 8000, { z: -10000 }, { z: 200 }, 4000)
        // .fromTo('.item__today-9', 200, { opacity: 0 }, { opacity: 1 }, 4000)
        // .to('.item__today-9', 200, { opacity: 0 }, 12000)

        // .to('.timeline__bg', 200, { opacity: 0 }, 12000)
        // screen 2 (2017)
        .to(
          ".item.item--anim.item__year.item__year-2017",
          1,
          { function: setCurrentFooter(1) },
          0
        )
        // .to('.timeline__header--part-1', 1, { opacity: 1 }, 0)
        .to(".item.item--anim.item__year.item__year-2017", 1, { opacity: 1 }, 0)

        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-3",
          1500,
          { z: -500 },
          { z: 300 },
          0
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-3",
          200,
          { opacity: 1 },
          { opacity: 1 },
          0
        )
        .to(
          ".item.item--anim.item__year.item__year-2017 .item__figure-3",
          200,
          { opacity: 0 },
          500
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__title",
          2000,
          { z: -1000 },
          { z: 300 },
          0
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__title",
          1,
          { opacity: 1 },
          { opacity: 1 },
          0
        )
        .to(
          ".item.item--anim.item__year.item__year-2017 .item__title",
          200,
          { opacity: 0 },
          1000
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 300 },
          0
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-1",
          200,
          { opacity: 1 },
          { opacity: 1 },
          0
        )
        .to(
          ".item.item--anim.item__year.item__year-2017 .item__figure-1",
          200,
          { opacity: 0 },
          1500
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-2",
          3000,
          { z: -2000 },
          { z: 300 },
          0
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2017 .item__figure-2",
          200,
          { opacity: 1 },
          { opacity: 1 },
          0
        )
        .to(
          ".item.item--anim.item__year.item__year-2017 .item__figure-2",
          200,
          { opacity: 0 },
          2000
        )

        // screen 3

        .to(
          ".item.item--anim.item__month.item__month-2017-01",
          1,
          { opacity: 1 },
          0
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-3",
          1500,
          { z: -500 },
          { z: 500 },
          1100
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          1100
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-3",
          200,
          { opacity: 0 },
          1600
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-1",
          2000,
          { z: -1000 },
          { z: 500 },
          1100
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          1100
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-1",
          200,
          { opacity: 0 },
          2100
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__caption",
          2500,
          { z: -1500 },
          { z: 500 },
          1100
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__caption",
          200,
          { opacity: 0 },
          { opacity: 1 },
          1100
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-01 .item__caption",
          200,
          { opacity: 0 },
          2500
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__title",
          2500,
          { z: -1500 },
          { z: 500 },
          1100
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          1100
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-01 .item__title",
          200,
          { opacity: 0 },
          2500
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-2",
          3000,
          { z: -2000 },
          { z: 500 },
          1100
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          1100
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-01 .item__figure-2",
          200,
          { opacity: 0 },
          3100
        )

        // //     // screen 3

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-1",
          1500,
          { z: -500, pointerEvents: "none" },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-1",
          200,
          { opacity: 0 },
          { opacity: 1, pointerEvents: "all" },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-1",
          200,
          { opacity: 0, pointerEvents: "none" },
          3100
        )

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-2",
          2500,
          { z: -1500 },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-2",
          200,
          { opacity: 0 },
          4100
        )

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-3",
          2500,
          { z: -1500 },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-3",
          200,
          { opacity: 0 },
          4100
        )

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-4",
          2500,
          { z: -1500 },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-4",
          200,
          { opacity: 0 },
          { opacity: 1 },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-4",
          200,
          { opacity: 0 },
          4100
        )

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-5",
          2500,
          { z: -1500 },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-5",
          200,
          { opacity: 0 },
          { opacity: 1 },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-5",
          200,
          { opacity: 0 },
          4100
        )

        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-6",
          2500,
          { z: -1500 },
          { z: 500 },
          2600
        )
        .fromTo(
          ".item.item__img.item__img-2017-01.item__img-2017-01-6",
          200,
          { opacity: 0 },
          { opacity: 1 },
          2600
        )
        .to(
          ".item.item__img.item__img-2017-01.item__img-2017-01-6",
          200,
          { opacity: 0 },
          4100
        )

        //       // screen 4

        .to(
          ".item.item--anim.item__month.item__month-2017-06",
          1,
          { opacity: 1 },
          4000
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          4000
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          4000
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-06 .item__figure-1",
          200,
          { opacity: 0 },
          4600
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__caption",
          2000,
          { z: -1000 },
          { z: 500 },
          4000
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__caption",
          200,
          { opacity: 0 },
          { opacity: 1 },
          4000
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-06 .item__caption",
          200,
          { opacity: 0 },
          5200
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          4000
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-06 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          4000
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-06 .item__title",
          200,
          { opacity: 0 },
          5200
        )

        //        // screen 5

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-1",
          1500,
          { z: -500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-1",
          200,
          { opacity: 0 },
          5800
        )

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-2",
          1500,
          { z: -500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-2",
          200,
          { opacity: 0 },
          5800
        )

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-4",
          1500,
          { z: -500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-4",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-4",
          200,
          { opacity: 0 },
          5800
        )

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-3",
          1500,
          { z: -500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-3",
          200,
          { opacity: 0 },
          5800
        )

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-5",
          2500,
          { z: -1500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-5",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-5",
          200,
          { opacity: 0 },
          6800
        )

        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-6",
          2500,
          { z: -1500 },
          { z: 500 },
          5300
        )
        .fromTo(
          ".item.item__img.item__img-2017-06.item__img-2017-06-6",
          200,
          { opacity: 0 },
          { opacity: 1 },
          5300
        )
        .to(
          ".item.item__img.item__img-2017-06.item__img-2017-06-6",
          200,
          { opacity: 0 },
          6800
        )

        //           // screen 6

        .to(
          ".item.item--anim.item__month.item__month-2017-12",
          1,
          { opacity: 1 },
          6600
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          6600
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          6600
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-2",
          200,
          { opacity: 0 },
          7100
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-1",
          2000,
          { z: -1000 },
          { z: 500 },
          6600
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          6600
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-1",
          200,
          { opacity: 0 },
          7600
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__caption",
          2500,
          { z: -1500 },
          { z: 500 },
          6600
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__caption",
          200,
          { opacity: 0 },
          { opacity: 1 },
          6600
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-12 .item__caption",
          200,
          { opacity: 0 },
          8100
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__title",
          2500,
          { z: -1500 },
          { z: 500 },
          6600
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          6600
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-12 .item__title",
          200,
          { opacity: 0 },
          8100
        )

        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-3",
          3000,
          { z: -2000 },
          { z: 500 },
          6600
        )
        .fromTo(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          6600
        )
        .to(
          ".item.item--anim.item__month.item__month-2017-12 .item__figure-3",
          200,
          { opacity: 0 },
          8600
        )

        //      // screen 7

        .to(
          ".item.item--anim.item__duo.item__duo-2017-1",
          1,
          { opacity: 1 },
          8200
        )

        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          8200
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          8200
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-2",
          200,
          { opacity: 0 },
          8700
        )

        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          8200
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          8200
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__inner",
          200,
          { opacity: 0 },
          9200
        )

        // .fromTo('.item.item--anim.item__duo.item__duo-2017-1 .item__img', !mob ? 2000 : 7500, { z: -1000 }, { z: 500 }, 8200)
        // .fromTo('.item.item--anim.item__duo.item__duo-2017-1 .item__img', !mob ? 200 : 4000, { opacity: 0 }, { opacity: 1 }, 8200)
        // .to('.item.item--anim.item__duo.item__duo-2017-1 .item__img', 200, { opacity: 0 }, !mob ? 9200 : 41800)

        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          8200
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          8200
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figures",
          1,
          { zIndex: !mob ? -1 : 1 },
          8200
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2017-1 .item__figure-1",
          200,
          { opacity: 0 },
          9700
        )

        //        // screen 8

        .to(
          ".item.item--anim.item__trio.item__trio-2017-1",
          1,
          { opacity: 1 },
          9300
        )

        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          9300
        )
        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          9300
        )
        .to(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-1",
          200,
          { opacity: 0 },
          9800
        )

        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__inner",
          2000,
          { z: -1000 },
          { z: !mob ? 500 : 500 },
          9300
        )
        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          9300
        )
        .to(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__inner",
          200,
          { opacity: 0 },
          10300
        )

        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-2",
          2500,
          { z: !mob ? -1500 : -1500 },
          { z: 500 },
          9300
        )
        .fromTo(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          9300
        )
        // mob ?
        // .to('.item.item--anim.item__trio.item__trio-2017-1 .item__figurs', 200, { opacity: 0 }, !mob ? 46400 : 47000)
        .to(
          ".item.item--anim.item__trio.item__trio-2017-1 .item__figure-2",
          200,
          { opacity: 0 },
          10800
        )

        // // screen 9 2018

        .to(
          ".item.item--anim.item__year.item__year-2018",
          1,
          { opacity: 1 },
          10400
        )
        .to(
          ".years.footer__years",
          1,
          { className: "years footer__years years--active-2" },
          10400
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          10400
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          10400
        )
        .to(
          ".item.item--anim.item__year.item__year-2018 .item__figure-1",
          200,
          { opacity: 0 },
          10900
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          10400
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          10400
        )
        .to(
          ".item.item--anim.item__year.item__year-2018 .item__title",
          200,
          { opacity: 0 },
          11400
        )

        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          10400
        )
        .fromTo(
          ".item.item--anim.item__year.item__year-2018 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          10400
        )
        .to(
          ".item.item--anim.item__year.item__year-2018 .item__figure-2",
          200,
          { opacity: 0 },
          11900
        )

        // // screen 10

        .fromTo(
          ".item.item__month.item__month-2018-03 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          11500
        )
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          11500
        )
        .to(
          ".item.item__month.item__month-2018-03 .item__figure-1",
          200,
          { opacity: 0 },
          12000
        )

        .to(".item.item__month.item__month-2018-03", 1, { opacity: 1 }, 11500)
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__caption",
          2500,
          { z: -1000 },
          { z: 500 },
          11500
        )
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__caption",
          200,
          { opacity: 0 },
          { opacity: 1 },
          11500
        )
        .to(
          ".item.item__month.item__month-2018-03 .item__caption",
          200,
          { opacity: 0 },
          12900
        )

        .to(".item.item__month.item__month-2018-03", 1, { opacity: 1 }, 11500)
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__title",
          2500,
          { z: -1000 },
          { z: 500 },
          11500
        )
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          11500
        )
        .to(
          ".item.item__month.item__month-2018-03 .item__title",
          200,
          { opacity: 0 },
          12900
        )

        .fromTo(
          ".item.item__month.item__month-2018-03 .item__text",
          2500,
          { z: -1000 },
          { z: 500 },
          11500
        )
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__text",
          200,
          { opacity: 0 },
          { opacity: 1 },
          11500
        )
        .to(
          ".item.item__month.item__month-2018-03 .item__text",
          200,
          { opacity: 0 },
          12900
        )

        // .to('.item.item__month.item__month-2018-03 .item__figure-2', 200, { zIndex: -1 }, 41500)
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__figure-2",
          3000,
          { z: -1500 },
          { z: 500 },
          11500
        )
        .fromTo(
          ".item.item__month.item__month-2018-03 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          11500
        )
        .to(
          ".item.item__month.item__month-2018-03 .item__figure-2",
          200,
          { opacity: 0 },
          13300
        )

        //     // screen 11
        .to(".item.item__duo.item__duo-2018-1", 1, { opacity: 1 }, 12900)
        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          12900
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          12900
        )
        .to(
          ".item.item__duo.item__duo-2018-1 .item__figure-1",
          200,
          { opacity: 0 },
          13400
        )
        // .to('.item.item__duo.item__duo-2018-1 .item__figures', 200, { zIndex: -1 }, 13400)

        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          12900
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          12900
        )
        .to(
          ".item.item__duo.item__duo-2018-1 .item__inner",
          200,
          { opacity: 0 },
          13900
        )

        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__figure-2",
          3000,
          { z: -1500 },
          { z: 500 },
          !mob ? 12900 : 12900
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          !mob ? 12900 : 12900
        )
        .to(
          ".item.item__duo.item__duo-2018-1 .item__figure-2",
          200,
          { opacity: 0 },
          !mob ? 14400 : 55400
        )

        //     // screen 12

        .to(".item.item__month.item__month-2018-06", 1, { opacity: 1 }, 14000)
        .fromTo(
          ".item.item__month.item__month-2018-06 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          14000
        )
        .fromTo(
          ".item.item__month.item__month-2018-06 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          14000
        )
        .to(
          ".item.item__month.item__month-2018-06 .item__figure-1",
          200,
          { opacity: 0 },
          14500
        )

        .fromTo(
          ".item.item__month.item__month-2018-06 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          14000
        )
        .fromTo(
          ".item.item__month.item__month-2018-06 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          14000
        )
        .to(
          ".item.item__month.item__month-2018-06 .item__inner",
          200,
          { opacity: 0 },
          15000
        )

        .fromTo(
          ".item.item__month.item__month-2018-06 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          14000
        )
        .fromTo(
          ".item.item__month.item__month-2018-06 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          14000
        )
        .to(
          ".item.item__month.item__month-2018-06 .item__figure-2",
          200,
          { opacity: 0 },
          15500
        )

        //     // screen 13
        // .to('.item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-1', 200, { zIndex: 2 }, 15100)
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-1",
          1500,
          { z: -500 },
          { z: 500 },
          15100
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          15100
        )
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-1",
          200,
          { opacity: 0 },
          15800
        )

        //     // screen 14

        .to(".item.item__month.item__month-2018-10 ", 1, { opacity: 1 }, 15900)
        .to(
          ".item.item__month.item__month-2018-10 .item__figure-1",
          1,
          { zIndex: -2 },
          16000
        )
        .fromTo(
          ".item.item__month.item__month-2018-10 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          15900
        )
        .fromTo(
          ".item.item__month.item__month-2018-10 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          15900
        )
        .to(
          ".item.item__month.item__month-2018-10 .item__figure-1",
          200,
          { opacity: 0 },
          16500
        )

        .fromTo(
          ".item.item__month.item__month-2018-10 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          15900
        )
        .fromTo(
          ".item.item__month.item__month-2018-10 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          15900
        )
        .to(
          ".item.item__month.item__month-2018-10 .item__inner",
          200,
          { opacity: 0 },
          17000
        )

        // .fromTo('.item.item__month.item__month-2018-10 .item__title', 3500, { z: -3000 }, { z: 500 }, 60000)
        // .fromTo('.item.item__month.item__month-2018-10 .item__title', 200, { opacity: 0 }, { opacity: 1 }, 60000)
        // .to('.item.item__month.item__month-2018-10 .item__title', 200, { opacity: 0 }, 62500)

        // .fromTo('.item.item__month.item__month-2018-10 .item__text', 3500, { z: -3500 }, { z: 500 }, 60500)
        // .fromTo('.item.item__month.item__month-2018-10 .item__text', 200, { opacity: 0 }, { opacity: 1 }, 60500)
        // .to('.item.item__month.item__month-2018-10 .item__text', 200, { opacity: 0 }, 63000)

        //     // screen 15
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2",
          1,
          { opacity: 1 },
          16900
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__image",
          1500,
          { z: -500 },
          { z: 500 },
          16900
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__image",
          200,
          { opacity: 0 },
          { opacity: 1 },
          17000
        )
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__image",
          200,
          { opacity: 0 },
          !mob ? 17500 : 17500
        );

      //     // screen 16

      fs.to(
        !mob &&
          ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1",
        1,
        { opacity: 1 },
        17600
      );
      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-1"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-1",
        1500,
        { z: -500 },
        { z: 500 },
        17600
      );
      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-1"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-1",
        200,
        { opacity: 0 },
        { opacity: 1 },
        17600
      );
      fs.to(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-1"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-1",
        200,
        { opacity: 0 },
        18100
      );

      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__text"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__text",
        2000,
        { z: -1000 },
        { z: 500 },
        17600
      );
      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__text"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__text",
        200,
        { opacity: 0 },
        { opacity: 1 },
        17600
      );
      fs.to(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__text"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__text",
        200,
        { opacity: 0 },
        !mob ? 18900 : 18900
      );

      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-2"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-2",
        2500,
        { z: -1500 },
        { z: 500 },
        17600
      );
      fs.fromTo(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-2"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-2",
        200,
        { opacity: 0 },
        { opacity: 1 },
        17600
      );
      fs.to(
        !mob
          ? ".item.item__solo.item__solo-2018.item__solo-2018-text.item__solo-2018-text-1 .item__figure-2"
          : ".item.item__solo.item__solo-2018.item__solo-2018-img.item__solo-2018-img-2 .item__figure-2",
        200,
        { opacity: 0 },
        !mob ? 19100 : 19100
      )

        // // screen 17

        .to(".item.item__month.item__month-2018-10-2", 1, { opacity: 1 }, 19000)
        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          19000
        )
        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          19000
        )
        .to(
          ".item.item__month.item__month-2018-10-2 .item__figure-1",
          200,
          { opacity: 0 },
          19500
        )

        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          19000
        )
        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          19000
        )
        .to(
          ".item.item__month.item__month-2018-10-2 .item__inner",
          200,
          { opacity: 0 },
          20000
        )

        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          19000
        )
        .fromTo(
          ".item.item__month.item__month-2018-10-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          19000
        )
        .to(
          ".item.item__month.item__month-2018-10-2 .item__figure-2",
          200,
          { opacity: 0 },
          20500
        )

        //     // screen 18

        .to(".item.item__duo.item__duo-2018-2", 1, { opacity: 1 }, 20100)
        .to(
          ".item.item__duo.item__duo-2018-2 .item__figures",
          1,
          { zIndex: -2 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          20100
        )
        .to(
          ".item.item__duo.item__duo-2018-2 .item__figure-2",
          200,
          { opacity: 0 },
          20600
        )

        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          20100
        )
        .to(
          ".item.item__duo.item__duo-2018-2 .item__inner",
          200,
          { opacity: 0 },
          21100
        )

        .to(
          ".item.item__duo.item__duo-2018-2 .item__left",
          1,
          { zIndex: !mob ? 0 : -1 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          20100
        )
        .to(
          ".item.item__duo.item__duo-2018-2 .item__figure-1",
          200,
          { opacity: 0 },
          21300
        )

        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-3",
          3000,
          { z: -2000 },
          { z: 500 },
          20100
        )
        .fromTo(
          ".item.item__duo.item__duo-2018-2 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          20100
        )
        .to(
          ".item.item__duo.item__duo-2018-2 .item__figure-3",
          200,
          { opacity: 0 },
          21800
        )

        //      // screen 19

        .to(".item.item__month.item__month-2018-11", 1, { opacity: 1 }, 21200)
        .fromTo(
          ".item.item__month.item__month-2018-11 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          21200
        )
        .fromTo(
          ".item.item__month.item__month-2018-11 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          21200
        )
        .to(
          ".item.item__month.item__month-2018-11 .item__figure-1",
          200,
          { opacity: 0 },
          21700
        )

        .fromTo(
          ".item.item__month.item__month-2018-11 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          21200
        )
        .fromTo(
          ".item.item__month.item__month-2018-11 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          21200
        )
        .to(
          ".item.item__month.item__month-2018-11 .item__inner",
          200,
          { opacity: 0 },
          22300
        )

        //      // screen 20
        .to(".item__duo.item__duo-2018-3", 1, { opacity: 1 }, 22300)
        .fromTo(
          ".item__duo.item__duo-2018-3 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          22300
        )
        .fromTo(
          ".item__duo.item__duo-2018-3 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          22300
        )
        .to(
          ".item__duo.item__duo-2018-3 .item__figure-2",
          200,
          { opacity: 0 },
          22800
        )

        .fromTo(
          ".item__duo.item__duo-2018-3 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          22300
        )
        .fromTo(
          ".item__duo.item__duo-2018-3 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          22300
        )
        .to(
          ".item__duo.item__duo-2018-3 .item__inner",
          200,
          { opacity: 0 },
          23300
        )

        .fromTo(
          ".item__duo.item__duo-2018-3 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          22300
        )
        .fromTo(
          ".item__duo.item__duo-2018-3 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          22300
        )
        .to(
          ".item__duo.item__duo-2018-3 .item__figure-1",
          200,
          { opacity: 0 },
          23600
        )

        //     // // screen 21 (2019)
        .to(
          ".years.footer__years",
          1,
          { className: "years footer__years years--active-3" },
          23400
        )
        .to(".item.item__year.item__year-2019", 200, { opacity: 1 }, 23400)
        .fromTo(
          ".item.item__year.item__year-2019 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          23400
        )
        .fromTo(
          ".item.item__year.item__year-2019 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          23400
        )
        .to(
          ".item.item__year.item__year-2019 .item__figure-2",
          200,
          { opacity: 0 },
          23900
        )

        .fromTo(
          ".item.item__year.item__year-2019 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          23400
        )
        .fromTo(
          ".item.item__year.item__year-2019 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          23400
        )
        .to(
          ".item.item__year.item__year-2019 .item__title",
          200,
          { opacity: 0 },
          24400
        )

        .fromTo(
          ".item.item__year.item__year-2019 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          23400
        )
        .fromTo(
          ".item.item__year.item__year-2019 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          23400
        )
        .to(
          ".item.item__year.item__year-2019 .item__figure-1",
          200,
          { opacity: 0 },
          24700
        )

        //     // screen 22

        .to(".item.item__month.item__month-2019-01", 1, { opacity: 1 }, 24500)
        .fromTo(
          ".item.item__month.item__month-2019-01 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          24500
        )
        .fromTo(
          ".item.item__month.item__month-2019-01 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          24500
        )
        .to(
          ".item.item__month.item__month-2019-01 .item__figure-2",
          200,
          { opacity: 0 },
          25000
        )

        .fromTo(
          ".item.item__month.item__month-2019-01 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          24500
        )
        .fromTo(
          ".item.item__month.item__month-2019-01 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          24500
        )
        .to(
          ".item.item__month.item__month-2019-01 .item__inner",
          200,
          { opacity: 0 },
          25500
        )

        .fromTo(
          ".item.item__month.item__month-2019-01 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          24500
        )
        .fromTo(
          ".item.item__month.item__month-2019-01 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          24500
        )
        .to(
          ".item.item__month.item__month-2019-01 .item__figure-1",
          200,
          { opacity: 0 },
          26000
        )

        //     // screen 23

        .to(".item.item__trio.item__trio-2019-1", 1, { opacity: 1 }, 25600)

        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          25600
        )
        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          25600
        )
        .to(
          ".item.item__trio.item__trio-2019-1 .item__figure-1",
          200,
          { opacity: 0 },
          26100
        )

        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          25600
        )
        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          25600
        )
        .to(
          ".item.item__trio.item__trio-2019-1 .item__inner",
          200,
          { opacity: 0 },
          26600
        )

        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          25600
        )
        // .to('.item.item__trio.item__trio-2019-1 .item__figures', 200, { zIndex: -1 }, 91000)
        .fromTo(
          ".item.item__trio.item__trio-2019-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          25600
        )
        .to(
          ".item.item__trio.item__trio-2019-1 .item__figure-2",
          200,
          { opacity: 0 },
          27100
        )

        //     // screen 24

        .to(
          ".item.item--anim.item--anim.item__month.item__month-2019-05",
          1,
          { opacity: 1 },
          26700
        )
        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          26700
        )
        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          26700
        )
        .to(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-1",
          200,
          { opacity: 0 },
          27200
        )

        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          26700
        )
        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          26700
        )
        .to(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__inner",
          200,
          { opacity: 0 },
          27700
        )

        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          26700
        )
        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          26700
        )
        .to(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-2",
          200,
          { opacity: 0 },
          28200
        )

        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-3",
          3000,
          { z: -2000 },
          { z: 500 },
          26700
        )
        .fromTo(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          26700
        )
        .to(
          ".item.item--anim.item--anim.item__month.item__month-2019-05 .item__figure-3",
          200,
          { opacity: 0 },
          28700
        )

        // screen 25

        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-1",
          2500,
          { z: -1500 },
          { z: 500 },
          27800
        )
        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          27800
        )
        .to(
          ".item.item__img.item__img-2019-05.item__img-2019-05-1",
          200,
          { opacity: 0 },
          29300
        )

        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-2",
          2500,
          { z: -1500 },
          { z: 500 },
          27800
        )
        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          27800
        )
        .to(
          ".item.item__img.item__img-2019-05.item__img-2019-05-2",
          200,
          { opacity: 0 },
          29300
        )

        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-3",
          2500,
          { z: -1500 },
          { z: 500 },
          27800
        )
        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          27800
        )
        .to(
          ".item.item__img.item__img-2019-05.item__img-2019-05-3",
          200,
          { opacity: 0 },
          29300
        )

        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-4",
          2500,
          { z: -1500 },
          { z: 500 },
          27800
        )
        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-4",
          200,
          { opacity: 0 },
          { opacity: 1 },
          27800
        )
        .to(
          ".item.item__img.item__img-2019-05.item__img-2019-05-4",
          200,
          { opacity: 0 },
          29300
        )

        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-5",
          2500,
          { z: -1500 },
          { z: 500 },
          27800
        )
        .fromTo(
          ".item.item__img.item__img-2019-05.item__img-2019-05-5",
          200,
          { opacity: 0 },
          { opacity: 1 },
          27800
        )
        .to(
          ".item.item__img.item__img-2019-05.item__img-2019-05-5",
          200,
          { opacity: 0 },
          29300
        )

        //     // screen 26

        .to(".item.item__month.item__month-2019-06", 1, { opacity: 1 }, 29400)
        .fromTo(
          ".item.item__month.item__month-2019-06 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          29400
        )
        .fromTo(
          ".item.item__month.item__month-2019-06 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          29400
        )
        .to(
          ".item.item__month.item__month-2019-06 .item__figure-2",
          200,
          { opacity: 0 },
          29900
        )

        .fromTo(
          ".item.item__month.item__month-2019-06 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          29400
        )
        .fromTo(
          ".item.item__month.item__month-2019-06 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          29400
        )
        .to(
          ".item.item__month.item__month-2019-06 .item__inner",
          200,
          { opacity: 0 },
          30400
        )

        .fromTo(
          ".item.item__month.item__month-2019-06 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          29400
        )
        .fromTo(
          ".item.item__month.item__month-2019-06 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          29400
        )
        .to(
          ".item.item__month.item__month-2019-06 .item__figure-1",
          200,
          { opacity: 0 },
          30900
        )

        //      // screen 27

        .to(
          ".item.item--anim.item__trio.item__trio-2019-2",
          1,
          { opacity: 1 },
          30500
        )

        .fromTo(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          30500
        )
        .fromTo(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          30500
        )
        .to(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__inner",
          200,
          { opacity: 0 },
          31500
        )

        .fromTo(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          30500
        )
        .fromTo(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          30500
        )
        .to(
          ".item.item--anim.item__trio.item__trio-2019-2 .item__figure-1",
          200,
          { opacity: 0 },
          32000
        )
        // .to('.timeline__header--part-1', 1, { opacity: 0 }, 32000)

        // screen 28 (2020)

        // .to('.timeline__header--part-2', 1, { opacity: 1 }, 30600)
        .to(
          ".years.footer__years",
          1,
          { className: "years footer__years years--active-4" },
          31600
        )
        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          31600
        )
        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          31600
        )
        .to(
          ".item.item__year.item__year-2020 .item__figure-2",
          200,
          { opacity: 0 },
          32100
        )

        .to(".item.item__year.item__year-2020", 1, { opacity: 1 }, 31600)
        .fromTo(
          ".item.item__year.item__year-2020 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          31600
        )
        .fromTo(
          ".item.item__year.item__year-2020 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          31600
        )
        .to(
          ".item.item__year.item__year-2020 .item__title",
          200,
          { opacity: 0 },
          32600
        )

        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          31600
        )
        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          31600
        )
        .to(
          ".item.item__year.item__year-2020 .item__figure-1",
          200,
          { opacity: 0 },
          33100
        )

        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-3",
          3000,
          { z: -2000 },
          { z: 500 },
          31600
        )
        .fromTo(
          ".item.item__year.item__year-2020 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          31600
        )
        .to(
          ".item.item__year.item__year-2020 .item__figure-3",
          200,
          { opacity: 0 },
          33600
        )

        //       // screen 9

        .to(".item.item__month.item__month-2020-03", 1, { opacity: 1 }, 32700)
        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-3",
          1500,
          { z: -500 },
          { z: 500 },
          32700
        )
        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          32700
        )
        .to(
          ".item.item__month.item__month-2020-03 .item__figure-3",
          200,
          { opacity: 0 },
          33200
        )

        .fromTo(
          ".item.item__month.item__month-2020-03 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          32700
        )
        .fromTo(
          ".item.item__month.item__month-2020-03 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          32700
        )
        .to(
          ".item.item__month.item__month-2020-03 .item__inner",
          200,
          { opacity: 0 },
          33700
        )

        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          32700
        )
        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          32700
        )
        .to(
          ".item.item__month.item__month-2020-03 .item__figure-1",
          200,
          { opacity: 0 },
          34200
        )

        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-2",
          3000,
          { z: -2000 },
          { z: 500 },
          32700
        )
        .fromTo(
          ".item.item__month.item__month-2020-03 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          32700
        )
        .to(
          ".item.item__month.item__month-2020-03 .item__figure-2",
          200,
          { opacity: 0 },
          34700
        )

        // //        // screen 30
        .to(".item.item__trio.item__trio-2020-1", 1, { opacity: 1 }, 33800)
        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__figure-1",
          2000,
          { z: -1000 },
          { z: 500 },
          33800
        )
        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          33800
        )
        .to(
          ".item.item__trio.item__trio-2020-1 .item__figure-1",
          200,
          { opacity: 0 },
          34800
        )

        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__inner",
          2500,
          { z: -1500 },
          { z: 500 },
          33800
        )
        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          33800
        )
        .to(
          ".item.item__trio.item__trio-2020-1 .item__inner",
          200,
          { opacity: 0 },
          35300
        )

        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__figure-2",
          3000,
          { z: -2000 },
          { z: 500 },
          33800
        )
        .fromTo(
          ".item.item__trio.item__trio-2020-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          33800
        )
        .to(
          ".item.item__trio.item__trio-2020-1 .item__figure-2",
          200,
          { opacity: 0 },
          36800
        )

        // //       // screen 30

        .to(".item.item__month.item__month-2020-03-2", 1, { opacity: 1 }, 35400)
        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          35400
        )
        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          35400
        )
        .to(
          ".item.item__month.item__month-2020-03-2 .item__figure-1",
          200,
          { opacity: 0 },
          35900
        )

        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          35400
        )
        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          35400
        )
        .to(
          ".item.item__month.item__month-2020-03-2 .item__inner",
          200,
          { opacity: 0 },
          36400
        )

        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          35400
        )
        .fromTo(
          ".item.item__month.item__month-2020-03-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          35400
        )
        .to(
          ".item.item__month.item__month-2020-03-2 .item__figure-2",
          200,
          { opacity: 0 },
          36900
        )

        // //        // screen 31

        .to(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-1",
          1,
          { opacity: 1 },
          36500
        )
        .fromTo(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          36500
        )
        .fromTo(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          36500
        )
        .to(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-1 .item__inner",
          200,
          { opacity: 0 },
          37500
        )

        // //        // screen 32

        .to(".item.item__month.item__month-2020-06", 1, { opacity: 1 }, 37600)
        .fromTo(
          ".item.item__month.item__month-2020-06 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          37600
        )
        .fromTo(
          ".item.item__month.item__month-2020-06 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          37600
        )
        .to(
          ".item.item__month.item__month-2020-06 .item__figure-2",
          200,
          { opacity: 0 },
          38100
        )

        .fromTo(
          ".item.item__month.item__month-2020-06 .item__inner",
          2500,
          { z: -1000 },
          { z: 500 },
          37600
        )
        .fromTo(
          ".item.item__month.item__month-2020-06 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          37600
        )
        .to(
          ".item.item__month.item__month-2020-06 .item__inner",
          200,
          { opacity: 0 },
          38800
        )

        .fromTo(
          ".item.item__month.item__month-2020-06 .item__figure-1",
          3000,
          { z: -1500 },
          { z: 500 },
          37600
        )
        .fromTo(
          ".item.item__month.item__month-2020-06 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          37600
        )
        .to(
          ".item.item__month.item__month-2020-06 .item__figure-1",
          200,
          { opacity: 0 },
          39100
        )

        // //        // screen 33

        .fromTo(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-2",
          2000,
          { z: -1000 },
          { z: 500 },
          38900
        )
        .fromTo(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          38900
        )
        .to(
          ".item.item__solo.item__solo-2020.item__solo-2020-img.item__solo-2020-img-2",
          200,
          { opacity: 0 },
          39900
        )

        // //  // screen 34

        .to(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1",
          1,
          { opacity: 1 },
          40000
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          40000
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          40000
        )
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          40500
        )

        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__text",
          2000,
          { z: -1000 },
          { z: 500 },
          40000
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__text",
          200,
          { opacity: 0 },
          { opacity: 1 },
          40000
        )
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__text",
          200,
          { opacity: 0 },
          41200
        )

        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          40000
        )
        .fromTo(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          40000
        )
        .to(
          ".item.item__solo.item__solo-2018.item__solo-2020-text.item__solo-2020-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          41500
        )

        // //        // screen 34  (2021)
        //  .to('.item.item__year.item__year-2021 ', 1, { zIndex: 2 }, 21600)
        .to(
          ".years.footer__years",
          1,
          { className: "years footer__years years--active-5" },
          41300
        )
        .to(".item.item__year.item__year-2021 ", 1, { opacity: 1 }, 41300)
        .fromTo(
          ".item.item__year.item__year-2021 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          41300
        )
        .fromTo(
          ".item.item__year.item__year-2021 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          41300
        )
        .to(
          ".item.item__year.item__year-2021 .item__figure-1",
          200,
          { opacity: 0 },
          41800
        )

        .fromTo(
          ".item.item__year.item__year-2021 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          41300
        )
        .fromTo(
          ".item.item__year.item__year-2021 .item__title",
          800,
          { opacity: 0 },
          { opacity: 1 },
          41300
        )
        .to(
          ".item.item__year.item__year-2021 .item__title",
          200,
          { opacity: 0 },
          42300
        )

        .fromTo(
          ".item.item__year.item__year-2021 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          41300
        )
        .fromTo(
          ".item.item__year.item__year-2021 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          41300
        )
        .to(
          ".item.item__year.item__year-2021 .item__figure-2",
          200,
          { opacity: 0 },
          42800
        )

        // //       // screen 35

        .to(".item.item__month.item__month-2021-01", 1, { opacity: 1 }, 42400)
        .fromTo(
          ".item.item__month.item__month-2021-01 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          42400
        )
        .fromTo(
          ".item.item__month.item__month-2021-01 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          42400
        )
        .to(
          ".item.item__month.item__month-2021-01 .item__figure-1",
          200,
          { opacity: 0 },
          42900
        )

        .fromTo(
          ".item.item__month.item__month-2021-01 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          42400
        )
        .fromTo(
          ".item.item__month.item__month-2021-01 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          42400
        )
        .to(
          ".item.item__month.item__month-2021-01 .item__inner",
          200,
          { opacity: 0 },
          43400
        )

        .to(
          ".item.item__month.item__month-2021-01 .item__figures",
          1,
          { zIndex: -2 },
          43000
        )
        .fromTo(
          ".item.item__month.item__month-2021-01 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          42400
        )
        .fromTo(
          ".item.item__month.item__month-2021-01 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          43000
        )
        .to(".item.item__month.item__month-2021-01", 1, { zIndex: 9 }, 43500)
        .to(
          ".item.item__month.item__month-2021-01 .item__figure-2",
          200,
          { opacity: 0 },
          43900
        )

        // //       // screen 36

        .to(
          ".item.item--anim.item__duo.item__duo-2021-1",
          1,
          { opacity: 1 },
          43500
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          43500
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          43500
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__figure-1",
          200,
          { opacity: 0 },
          44000
        )

        // .to('.item.item--anim.item__duo.item__duo-2021-1', 1, { zIndex: 2 }, 128200)
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          43500
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          43500
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2021-1 .item__inner",
          200,
          { opacity: 0 },
          44500
        )

        // //       // screen 37

        .to(".item.item__month.item__month-2021-01-2", 1, { opacity: 1 }, 44600)
        // .to('.item.item__month.item__month-2021-01-2', 1, { zIndex: -1 }, 28500)
        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          44600
        )
        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          44600
        )
        .to(
          ".item.item__month.item__month-2021-01-2 .item__figure-2",
          200,
          { opacity: 0 },
          45100
        )

        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          44600
        )
        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          44600
        )
        .to(
          ".item.item__month.item__month-2021-01-2 .item__inner",
          200,
          { opacity: 0 },
          45600
        )

        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          44600
        )
        .fromTo(
          ".item.item__month.item__month-2021-01-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          44600
        )
        .to(
          ".item.item__month.item__month-2021-01-2 .item__figure-1",
          200,
          { opacity: 0 },
          46100
        )

        // //      // screen 38

        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1",
          1,
          { opacity: 1 },
          45700
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-1",
          2000,
          { z: -1000 },
          { z: 500 },
          45700
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          45700
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-1",
          200,
          { opacity: 0 },
          46700
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__inner",
          2500,
          { z: -1500 },
          { z: 500 },
          45700
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          45700
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__inner",
          200,
          { opacity: 0 },
          47200
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-2",
          3000,
          { z: -2000 },
          { z: 500 },
          45700
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          47200
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-1 .item__figure-2",
          200,
          { opacity: 0 },
          47600
        )

        // //  // screen 39

        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1",
          1,
          { opacity: 1 },
          47300
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          47300
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          47300
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          47800
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          47300
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          47300
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          48000
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__text",
          2000,
          { z: -1000 },
          { z: 500 },
          47300
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__text",
          200,
          { opacity: 0 },
          { opacity: 1 },
          47300
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__text",
          200,
          { opacity: 0 },
          48600
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-3",
          2500,
          { z: -1500 },
          { z: 500 },
          47300
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          47300
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-1 .item__figure-3",
          200,
          { opacity: 0 },
          49000
        )

        // //  // screen 40

        .to(".item.item__month.item__month-2021-09", 1, { opacity: 1 }, 48700)
        .fromTo(
          ".item.item__month.item__month-2021-09 .item__inner",
          1500,
          { z: -500 },
          { z: 500 },
          48700
        )
        .fromTo(
          ".item.item__month.item__month-2021-09 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          48700
        )
        .to(
          ".item.item__month.item__month-2021-09 .item__inner",
          200,
          { opacity: 0 },
          49300
        )

        .fromTo(
          ".item.item__month.item__month-2021-09 .item__figure-1",
          2000,
          { z: -1000 },
          { z: 500 },
          48700
        )
        .fromTo(
          ".item.item__month.item__month-2021-09 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          48700
        )
        .to(
          ".item.item__month.item__month-2021-09 .item__figure-1",
          200,
          { opacity: 0 },
          49700
        )

        // //        // screen 41

        .to(
          ".item.item--anim.item__duo.item__duo-2021-2",
          1,
          { opacity: 1 },
          49400
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-2  .item__inner",
          2500,
          { z: -1500 },
          { z: 500 },
          49400
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-2  .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          49400
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2021-2 .item__inner",
          200,
          { opacity: 0 },
          50900
        )

        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-2 .item__figure-1",
          3000,
          { z: -2000 },
          { z: 500 },
          49400
        )
        .fromTo(
          ".item.item--anim.item__duo.item__duo-2021-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          49400
        )
        .to(
          ".item.item--anim.item__duo.item__duo-2021-2 .item__figure-1",
          200,
          { opacity: 0 },
          51400
        )

        // //        // screen 42

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-2",
          1500,
          { z: -500, pointerEvents: "none" },
          { z: 500 },
          51000
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-2",
          200,
          { opacity: 0 },
          { opacity: 1, pointerEvents: "all" },
          51000
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-img.item__solo-2021-img-2",
          200,
          { opacity: 0, pointerEvents: "none" },
          51500
        )

        // //     // screen 43

        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2",
          1,
          { opacity: 1 },
          51600
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          51600
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          51600
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-1",
          200,
          { opacity: 0 },
          52100
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-3",
          1500,
          { z: -500 },
          { z: 500 },
          51600
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          51600
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-3",
          200,
          { opacity: 0 },
          52500
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__text",
          1500,
          { z: -1000 },
          { z: 500 },
          51600
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__text",
          200,
          { opacity: 0 },
          { opacity: 1 },
          51600
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__text",
          200,
          { opacity: 0 },
          52600
        )

        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-2",
          2000,
          { z: -1500 },
          { z: 500 },
          51600
        )
        .fromTo(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          51600
        )
        .to(
          ".item.item__solo.item__solo-2021.item__solo-2021-text.item__solo-2021-text-2 .item__figure-2",
          200,
          { opacity: 0 },
          53000
        )

        // //     // screen 44

        .to(".item.item__month.item__month-2021-12", 1, { opacity: 1 }, 52700)
        .fromTo(
          ".item.item__month.item__month-2021-12 .item__inner",
          1500,
          { z: -500 },
          { z: 500 },
          52700
        )
        .fromTo(
          ".item.item__month.item__month-2021-12 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          52700
        )
        .to(
          ".item.item__month.item__month-2021-12 .item__inner",
          200,
          { opacity: 0 },
          53200
        )

        // //        // screen 45

        .to(".item.item__duo.item__duo-2021-3", 1, { opacity: 1 }, 53300)
        .fromTo(
          ".item.item__duo.item__duo-2021-3 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          53300
        )
        .fromTo(
          ".item.item__duo.item__duo-2021-3 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          53300
        )
        .to(
          ".item.item__duo.item__duo-2021-3 .item__figure-1",
          200,
          { opacity: 0 },
          53800
        )

        .fromTo(
          ".item.item__duo.item__duo-2021-3 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          53300
        )
        .fromTo(
          ".item.item__duo.item__duo-2021-3 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          53300
        )
        .to(
          ".item.item__duo.item__duo-2021-3 .item__inner",
          200,
          { opacity: 0 },
          54300
        )

        // //       // screen 46  (2022)
        .to(
          ".years.footer__years",
          1,
          { className: "years footer__years years--active-6" },
          54400
        )
        .to(".item.item__year.item__year-2022", 1, { opacity: 1 }, 54400)
        .fromTo(
          ".item.item__year.item__year-2022 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          54400
        )
        .fromTo(
          ".item.item__year.item__year-2022 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          54400
        )
        .to(
          ".item.item__year.item__year-2022 .item__figure-2",
          200,
          { opacity: 0 },
          54900
        )

        .fromTo(
          ".item.item__year.item__year-2022 .item__title",
          2000,
          { z: -1000 },
          { z: 500 },
          54400
        )
        .fromTo(
          ".item.item__year.item__year-2022 .item__title",
          200,
          { opacity: 0 },
          { opacity: 1 },
          54400
        )
        .to(
          ".item.item__year.item__year-2022 .item__title",
          200,
          { opacity: 0 },
          55400
        )

        .fromTo(
          ".item.item__year.item__year-2022 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          54400
        )
        .fromTo(
          ".item.item__year.item__year-2022 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          54400
        )
        .to(
          ".item.item__year.item__year-2022 .item__figure-1",
          200,
          { opacity: 0 },
          55900
        )

        // //         // screen 47

        .to(".item.item__month.item__month-2022-10", 1, { opacity: 1 }, 55500)
        .fromTo(
          ".item.item__month.item__month-2022-10 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          55500
        )
        .fromTo(
          ".item.item__month.item__month-2022-10 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          55500
        )
        .to(
          ".item.item__month.item__month-2022-10 .item__figure-2",
          200,
          { opacity: 0 },
          56000
        )

        .fromTo(
          ".item.item__month.item__month-2022-10 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          55500
        )
        .fromTo(
          ".item.item__month.item__month-2022-10 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          55500
        )
        .to(
          ".item.item__month.item__month-2022-10 .item__inner",
          200,
          { opacity: 0 },
          56500
        )

        .fromTo(
          ".item.item__month.item__month-2022-10 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          55500
        )
        .fromTo(
          ".item.item__month.item__month-2022-10 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          55500
        )
        .to(
          ".item.item__month.item__month-2022-10 .item__figure-1",
          200,
          { opacity: 0 },
          57000
        )

        // //       // screen 48

        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1",
          1,
          { opacity: 1 },
          56600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__image",
          2500,
          { z: -1000 },
          { z: 500 },
          56600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__image",
          200,
          { opacity: 0 },
          { opacity: 1 },
          56600
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__image",
          200,
          { opacity: 0 },
          57700
        )

        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          56600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          56600
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-1 .item__figure-1",
          200,
          { opacity: 0 },
          58100
        )

        // //  // screen 49

        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1",
          1,
          { opacity: 1 },
          57800
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          57800
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          57800
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-1",
          200,
          { opacity: 0 },
          58300
        )

        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__text",
          2000,
          { z: -1000 },
          { z: 500 },
          57800
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__text",
          200,
          { opacity: 0 },
          { opacity: 1 },
          57800
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__text",
          200,
          { opacity: 0 },
          59000
        )

        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          57800
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          57800
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-text.item__solo-2022-text-1 .item__figure-2",
          200,
          { opacity: 0 },
          59300
        )

        // //  // screen 50

        .to(".item.item__month.item__month-2022-10-2", 1, { opacity: 1 }, 59100)
        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          59100
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          59100
        )
        .to(
          ".item.item__month.item__month-2022-10-2 .item__figure-1",
          200,
          { opacity: 0 },
          59600
        )

        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          59100
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          59100
        )
        .to(
          ".item.item__month.item__month-2022-10-2 .item__inner",
          200,
          { opacity: 0 },
          60100
        )

        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          59100
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          59100
        )
        .to(
          ".item.item__month.item__month-2022-10-2 .item__figure-2",
          200,
          { opacity: 0 },
          60600
        )

        // //       // screen 51

        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-2",
          2000,
          { z: -1000 },
          { z: 500 },
          60200
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          60200
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-2",
          200,
          { opacity: 0 },
          61200
        )

        // //     // screen 52

        .to(".item.item__month.item__month-2022-10-3", 1, { opacity: 1 }, 61300)
        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          61300
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          61300
        )
        .to(
          ".item.item__month.item__month-2022-10-3 .item__figure-2",
          200,
          { opacity: 0 },
          61800
        )

        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          61300
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          61300
        )
        .to(
          ".item.item__month.item__month-2022-10-3 .item__inner",
          200,
          { opacity: 0 },
          62300
        )

        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          61300
        )
        .fromTo(
          ".item.item__month.item__month-2022-10-3 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          61300
        )
        .to(
          ".item.item__month.item__month-2022-10-3 .item__figure-1",
          200,
          { opacity: 0 },
          62800
        )

        // //           // screen 53

        .to(".item.item__month.item__month-2022-11", 1, { opacity: 1 }, 62400)
        .fromTo(
          ".item.item__month.item__month-2022-11 .item__figure-2",
          1500,
          { z: -500 },
          { z: 500 },
          62400
        )
        .fromTo(
          ".item.item__month.item__month-2022-11 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          62400
        )
        .to(
          ".item.item__month.item__month-2022-11 .item__figure-2",
          200,
          { opacity: 0 },
          62900
        )

        .fromTo(
          ".item.item__month.item__month-2022-11 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          62400
        )
        .fromTo(
          ".item.item__month.item__month-2022-11 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          62400
        )
        .to(
          ".item.item__month.item__month-2022-11 .item__inner",
          200,
          { opacity: 0 },
          63400
        )

        .fromTo(
          ".item.item__month.item__month-2022-11 .item__figure-1",
          2500,
          { z: -1500 },
          { z: 500 },
          62400
        )
        .fromTo(
          ".item.item__month.item__month-2022-11 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          62400
        )
        .to(
          ".item.item__month.item__month-2022-11 .item__figure-1",
          200,
          { opacity: 0 },
          63900
        )

        // //          // screen 54

        .fromTo(
          ".item.item__img.item__img-2022-01.item__img-2022-01-1",
          2000,
          { z: -1000 },
          { z: 500 },
          63500
        )
        .fromTo(
          ".item.item__img.item__img-2022-01.item__img-2022-01-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          63500
        )
        .to(
          ".item.item__img.item__img-2022-01.item__img-2022-01-1",
          200,
          { opacity: 0 },
          64500
        )

        .fromTo(
          ".item.item__img.item__img-2022-01.item__img-2022-01-2",
          2500,
          { z: -1500 },
          { z: 500 },
          63500
        )
        .fromTo(
          ".item.item__img.item__img-2022-01.item__img-2022-01-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          63500
        )
        .to(
          ".item.item__img.item__img-2022-01.item__img-2022-01-2",
          200,
          { opacity: 0 },
          65000
        )

        // //       // screen 55

        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1",
          1,
          { opacity: 1 },
          64600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          64600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          64600
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__figure-1",
          200,
          { opacity: 0 },
          65100
        )

        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          64600
        )
        .fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          64600
        )
        .to(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3.item__solo-2022-img-3-1 .item__inner",
          200,
          { opacity: 0 },
          65600
        )

        // //     // screen 56

        .to(".item.item__month.item__month-2022-11-2", 1, { opacity: 1 }, 65700)
        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          65700
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          65700
        )
        .to(
          ".item.item__month.item__month-2022-11-2 .item__figure-1",
          200,
          { opacity: 0 },
          66200
        )

        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          65700
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          65700
        )
        .to(
          ".item.item__month.item__month-2022-11-2 .item__inner",
          200,
          { opacity: 0 },
          66700
        )

        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          65700
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-2 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          65700
        )
        .to(
          ".item.item__month.item__month-2022-11-2 .item__figure-2",
          200,
          { opacity: 0 },
          67200
        )

        // //        // screen 57

        .to(".item.item__trio.item__trio-2022-1", 1, { opacity: 1 }, 66800)
        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          66800
        )
        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          66800
        )
        .to(
          ".item.item__trio.item__trio-2022-1 .item__figure-1",
          200,
          { opacity: 0 },
          67300
        )

        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          66800
        )
        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          66800
        )
        .to(
          ".item.item__trio.item__trio-2022-1 .item__inner",
          200,
          { opacity: 0 },
          67800
        )

        // .to('.item.item__trio.item__trio-2022-1 .item__figures', 1, { zIndex: -1 }, 95600)
        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          66800
        )
        .fromTo(
          ".item.item__trio.item__trio-2022-1 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          66800
        )
        .to(
          ".item.item__trio.item__trio-2022-1 .item__figure-2",
          200,
          { opacity: 0 },
          68300
        )

        // //       // screen 58

        .to(".item.item__month.item__month-2022-11-3", 1, { opacity: 1 }, 67900)
        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-1",
          1500,
          { z: -500 },
          { z: 500 },
          67900
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          67900
        )
        .to(
          ".item.item__month.item__month-2022-11-3 .item__figure-1",
          200,
          { opacity: 0 },
          68400
        )

        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-3",
          1500,
          { z: -500 },
          { z: 500 },
          67900
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          67900
        )
        .to(
          ".item.item__month.item__month-2022-11-3 .item__figure-3",
          200,
          { opacity: 0 },
          68400
        )

        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__inner",
          2000,
          { z: -1000 },
          { z: 500 },
          67900
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__inner",
          200,
          { opacity: 0 },
          { opacity: 1 },
          67900
        )
        .to(
          ".item.item__month.item__month-2022-11-3 .item__inner",
          200,
          { opacity: 0 },
          68900
        )

        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-2",
          2500,
          { z: -1500 },
          { z: 500 },
          67900
        )
        .fromTo(
          ".item.item__month.item__month-2022-11-3 .item__figure-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          67900
        )
        .to(
          ".item.item__month.item__month-2022-11-3 .item__figure-2",
          200,
          { opacity: 0 },
          69400
        );

      // //           // screen 58

      if (!mob) {
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          1500,
          { z: -500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          200,
          { opacity: 0 },
          69500
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          1500,
          { z: -500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          200,
          { opacity: 0 },
          69500
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92",
          1500,
          { z: -500 },
          { z: 300 },
          69600
        );
        fs.fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69600
        );
        // fs.to('.item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92', 200, { opacity: 0 }, 70500)
      } else {
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          1500,
          { z: -500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-1",
          200,
          { opacity: 0 },
          69500
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-2",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-3",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          2000,
          { z: -1000 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-6",
          200,
          { opacity: 0 },
          70000
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          2500,
          { z: -1500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-7",
          200,
          { opacity: 0 },
          70500
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          2500,
          { z: -1500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-5",
          200,
          { opacity: 0 },
          70500
        );

        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          2500,
          { z: -1500 },
          { z: 500 },
          69000
        );
        fs.fromTo(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          200,
          { opacity: 0 },
          { opacity: 1 },
          69000
        );
        fs.to(
          ".item.item__img.item__img-2022-02.item__img-2022-02-4",
          200,
          { opacity: 0 },
          70500
        );

        fs.fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92",
          1500,
          { z: -500 },
          { z: 0 },
          70600
        );
        fs.fromTo(
          ".item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92",
          200,
          { opacity: 0 },
          { opacity: 1 },
          70600
        );
        // fs.to('.item.item__solo.item__solo-2022.item__solo-2022-img.item__solo-2022-img-3._92', 200, { opacity: 0 }, 71100)
      }

      let links = gsap.utils.toArray(".years__item");
      console.log("links: ", links);
      links.forEach((a) => {
        let element = document.querySelector(a.getAttribute("href")),
          linkST = ScrollTrigger.create({
            trigger: element,
            start: "top top",
          });
        ScrollTrigger.create({
          trigger: element,
          start: "top center",
          end: "bottom center",
          onToggle: (self) => self.isActive && setActive(a),
        });
        a.addEventListener("click", (e) => {
          e.preventDefault();
          setScroll(e);
        });

        function setActive(link) {
          links.forEach((el) => el.classList.remove("active"));
          link.classList.add("active");
        }
      });
    }
  }, [load]);

  let setScroll = (e) => {
    let num;

    if (e.target) {
      const href = e.target.getAttribute("href");

      switch (href) {
        case "#y2017":
          num = 0;
          break;
        case "#y2018":
          num = 10400;
          break;
        case "#y2019":
          num = 23400;
          break;
        case "#y2020":
          num = 31600;
          break;
        case "#y2021":
          num = 41300;
          break;
        case "#y2022":
          num = 54400;
          break;
      }
    } else {
      switch (e) {
        case 2017:
          num = 0;
          break;
        case 2018:
          num = 10400;
          break;
        case 2019:
          num = 23400;
          break;
        case 2020:
          num = 31600;
          break;
        case 2021:
          num = 41300;
          break;
        case 2022:
          num = 54400;
          break;
      }
    }

    gsap.to(window, { duration: 1, scrollTo: num, overwrite: "auto" });
  };

  useEffect(() => {
    if (anchor && load) {
      console.log("anchor: ", anchor);

      // const interval = setInterval(() => {
      //   console.log('load: ', load);
      //   if (load) {

      console.log("ancors: ", anchor);
      setScroll(anchor.years);
      // clearInterval(interval);
      // }
      // }, 500);
    }
  }, [anchor, load]);

  useEffect(() => {
    setGo(true);
    getLoadingImg();
  }, []);

  function getLoadingImg() {
    let num = 0;
    const imgs = document.querySelectorAll(".timeline img");

    const result = Array.from(imgs);
    console.log("result: ", result);

    for (let img of result) {
      img.onload = function (e) {
        if (load) {
          console.log("ss");
        }

        num = num + 1;
        // console.log('num: ', num);
        // console.log('result.length: ', result.length);
        if ((num) => 100) {
          setTimeout(() => {
            setLoad(true);
          }, [5000]);
        }
      };
    }
  }

  const setCurrentFooter = (index) => {
    console.log("index: ", index);
    const footerYears = document.querySelector(".years");

    if (footerYears) {
      for (let i = 0; i < 5; i++) {
        footerYears.classList.remove(`years--active-${i}`);
      }

      if (index === 1) return footerYears.classList.add("years--active-1");
      if (index === 2) return footerYears.classList.add("years--active-2");
      if (index === 3) return footerYears.classList.add("years--active-3");
      if (index === 4) return footerYears.classList.add("years--active-4");
    }
  };

  return (
    <>
      {go && (
        <>
          <div className={cn("three-load", load && "three-load--hide")}>
            {/* <img src="img/three/three-load.png" alt="" /> */}
            <div className="blobs">
              <div className="blob-center"></div>
              <div className="blob"></div>
              <div className="blob"></div>
              <div className="blob"></div>
              <div className="blob"></div>
              <div className="blob"></div>
              <div className="blob"></div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="goo">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="10"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    mode="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                    result="goo"
                  />
                  <feBlend in="SourceGraphic" in2="goo" />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="timeline">
            <div className="timeline__items">
              {/* today */}
              {/* <FirstScreen/> */}
              <div className="timeline__fs">
                <Header components="three" setCurrentDate={setCurrentDate} />

                {/* <div className="timeline__bg"></div> */}
                {/* <section className="item item__today item__today-1">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-1.png"
                srcSet="img/three/today/today-1@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-2 none">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-2.png"
                srcSet="img/three/today/today-2@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-3">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-3.png"
                srcSet="img/three/today/today-3@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-4">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-4.png"
                srcSet="img/three/today/today-4@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-5 none">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-5.png"
                srcSet="img/three/today/today-5@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-6">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-6.png"
                srcSet="img/three/today/today-6@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-7">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-7.png"
                srcSet="img/three/today/today-7@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-8">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-8.png"
                srcSet="img/three/today/today-8@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section>

        <section className="item item__today item__today-9">
          <div className="item__wrapper">
            <div className="item__image">
              <img
                src="img/three/today/today-9.png"
                srcSet="img/three/today/today-9@2x.png 2x"
                alt=""
              />
            </div>
          </div>
        </section> */}

                <section
                  className="item item--anim item__year item__year-2017"
                  id="y2017"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2017</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-semicircle-red.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img src="img/three/figure-rhombus-blue.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-3">
                        <img src="img/three/figure-pill-violet.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__month item__month-2017-01">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__caption">Январь</div>
                      <h2 className="item__title">
                        10 лет «Авито» Рекламная кампания «Люди — Людям»
                      </h2>
                      <div className="item__text"></div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>

                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>

                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-1">
                  <div className="item__wrapper">
                    <div className="item__image">
                      {/* <img
                  src="img/three/2017/2017-01-1.png"
                  srcSet="img/three/2017/2017-01-1@2x.png 2x"
                  alt=""
                /> */}
                      {/* <iframe
                  src="https://player.vimeo.com/video/258470373?h=b8595c1866?controls=0"
                  width="671"
                  height="376"
               
                  // allow="autoplay; fullscreen; picture-in-picture"

                  // allowfullscreen
                ></iframe> */}

                      <iframe
                        width="671"
                        height="376"
                        src="https://player.vimeo.com/video/258470373?h=b8595c1866"
                        srcDoc="<style>*{z-index:10;padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://player.vimeo.com/video/258470373?h=b8595c1866&muted=1&autoplay=1><img src=img/three/2017/2017-01-1.png alt='img'> <div style='display: block;position: absolute;left: calc(50% - 28px) ;top: calc(50% - 28px);width: 56px;height: 56px;'>
                                      <img src='img/three/play-button.svg' alt='' /></div></a>"
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        title=""
                      ></iframe>

                      {/* <div className="item__play">
                  <img src="img/three/play-button.svg" alt="" />
                </div> */}
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-2">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-01-2.png"
                        srcSet="img/three/2017/2017-01-2@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-3">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-01-3.png"
                        srcSet="img/three/2017/2017-01-3@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-4">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-01-4.png"
                        srcSet="img/three/2017/2017-01-4@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-5">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-01-5.png"
                        srcSet="img/three/2017/2017-01-5@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-01 item__img-2017-01-6">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-01-6.png"
                        srcSet="img/three/2017/2017-01-6@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__month item__month-2017-06">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__caption">Июнь</div>
                      <h2 className="item__title">
                        Офис «Авито» в «Белых Садах» получает премию Best Office
                        Awards
                      </h2>
                      <div className="item__text"></div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-blue.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-1">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-1.png"
                        srcSet="img/three/2017/2017-06-1@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-2">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-2.png"
                        srcSet="img/three/2017/2017-06-2@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-3">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-3.png"
                        srcSet="img/three/2017/2017-06-3@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-4">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-4.png"
                        srcSet="img/three/2017/2017-06-4@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-5">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-5.png"
                        srcSet="img/three/2017/2017-06-5@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2017-06 item__img-2017-06-6">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2017/2017-06-6.png"
                        srcSet="img/three/2017/2017-06-6@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__month item__month-2017-12">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__caption">Декабрь</div>
                      <h2 className="item__title">
                        Голосовое управление, публичный профиль и защита
                        персональных данных
                      </h2>
                      <div className="item__text"></div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-trapeze-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-3">
                          <img
                            src="img/three/figure-rhombus-green.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__duo item__duo-2017-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text">
                            <p>
                              «Авито» запускает голосовое управление и поиск
                              товаров по фотографиям. Последний позволяет найти
                              аналогичный или похожий товар по фото (даже
                              автомобиль). Появляется функция защиты
                              персональных данных: скрытие лиц и номеров, Voice
                              Over, 3D Touch.
                            </p>

                            <p className="desktop">
                              В публичном профиле становится видна информация о
                              продавцах и их объявлениях. Доверие покупателей
                              растёт.
                            </p>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2017-duo-1.png"
                              srcSet="img/three/2017-duo-1@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__text mobile">
                            <p>
                              В публичном профиле становится видна информация о
                              продавцах и их объявлениях. Доверие покупателей
                              растёт.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1 desktop">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-ticket-green.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__trio item__trio-2017-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text">
                            <p>
                              К окончанию года число активных объявлений на
                              Авито превысило
                            </p>
                          </div>
                          <div className="item__subtitle">40 млн.</div>
                        </div>
                        <div className="item__center">
                          <div className="item__text">
                            <p>
                              Мобильное приложение «Авито» возглавило рейтинг
                              лучших сервисов для поиска работы. Соответствующие
                              результаты были представлены Роскачеством по
                              результатам исследования 27 приложений на базе
                              Android.
                            </p>
                          </div>
                        </div>
                        <div className="item__right">
                          <div className="item__text">
                            <p>В компании работает уже</p>
                          </div>
                          <div className="item__subtitle">
                            1,6 тыс. сотрудников
                          </div>
                        </div>
                      </div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* 2018 */}

                <section
                  className="item item--anim item__year item__year-2018"
                  id="y2018"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2018</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-rhombus-blue.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img src="img/three/figure-pill-red.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__month item__month-2018-03">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__caption">Март</div>
                      <h2 className="item__title">
                        650 российских городов для доставки
                      </h2>
                      <div className="item__text">
                        К доставке подключилась служба Boxberry, платежные
                        партнеры — «Тинькофф Банк» и Qiwi. За два месяца
                        пользователи «Авито» подключили к доставке 5 млн
                        объявлений — больше трети всех товаров на сайте. Позже
                        платформа начал сотрудничать с коммерческим оператором
                        доставки DPD.
                      </div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__duo item__duo-2018-1 item--anim item--anim-show">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text">
                            <p>
                              «Авито» признан самой популярной площадкой для
                              поиска работы в России, согласно опросу НАФИ.
                            </p>
                          </div>

                          <div className="item__note">
                            <div className="item__note-text">
                              <p>За два месяца пользователи отправили </p>
                            </div>
                            <div className="item__note-title">
                              <p>66 тыс. товаров</p>
                            </div>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2018/2018-duo-1.png"
                              srcSet="img/three/2018/2018-duo-1@2x.png 2x"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-hexagon-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2018-06">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Июнь</div>
                        <h2 className="item__title">
                          Онлайн-бронирование жилья в 11 городах России
                        </h2>
                        <div className="item__text">
                          В преддверии Чемпионата мира по футболу «Авито»
                          запускает сервис краткосрочной аренды жилья — первую в
                          России альтернативу международным системам
                          бронирования.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-diamond-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2018 item__solo-2018-img item__solo-2018-img-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        <img
                          src="img/three/2018/2018-img-1.png"
                          srcSet="img/three/2018/2018-img-1@2x.png 2x"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim  item--anim-show item__month item__month-2018-10">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Октябрь</div>
                        <h2 className="item__title">Искусственный интелект</h2>
                        <div className="item__text">
                          «Авито» внедрил искусственный интеллект, который помог
                          запустить систему рекомендаций и умного поиска. Сервис
                          стал удобнее, благодаря чему увеличилось число
                          пользователей и их среднее время на сайте, а также
                          процент возвращения и повторного использования.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2018 item__solo-2018-img item__solo-2018-img-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        {/* <img
                    src="img/three/2018/2018-img-2.png"
                    srcSet="img/three/2018/2018-img-2@2x.png 2x"
                    alt=""
                  /> */}
                        <picture>
                          <source
                            src="img/three/2018/2018-img-2.png"
                            srcSet="img/three/2018/2018-img-2@2x.png 2x"
                            alt=""
                            media="(min-width: 768px)"
                          />
                          <img
                            src="img/three/2018/2018-img-2-m.png"
                            srcSet="img/three/2018/2018-img-2-m@2x.png 2x"
                            alt=""
                            media="(max-width: 767.9px)"
                          />
                        </picture>
                      </div>
                      <div className="item__text mobile">
                        «Авито» и «Российские автомобильные дилеры» объединяют
                        «Автотеку» с Национальной базой данных по автомобилям.
                      </div>

                      <div className="item__figures mobile">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2018 item__solo-2018-text item__solo-2018-text-1 desktop">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          «Авито» и «Российские автомобильные дилеры» объединяют
                          «Автотеку» с Национальной базой данных по автомобилям.
                        </p>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2018-10-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Октябрь</div>
                        <h2 className="item__title">Рейтинги и отзывы</h2>
                        <div className="item__text">
                          Стартовало тестирование рейтингов и отзывов на
                          «Авито». Этот шаг стал новым этапом в
                          совершенствовании пользовательского опыта. Покупатели
                          получили возможность оценить совершенную сделку и
                          поделиться впечатлениями о продавце, влияя тем самым
                          на его рейтинг.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-triangle-violet.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-ticket-green.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__duo item__duo-2018-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__img">
                            <img
                              src="img/three/2018/2018-duo-2-1.png"
                              srcSet="img/three/2018/2018-duo-2-1@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__note mobile">
                            <div className="item__note-text">
                              <p>
                                Согласно исследованиям, в 90% случаев решение об
                                онлайн-покупке клиент принимает с использованием
                                отзывов и склонен доверять продавцу с большим
                                количеством положительных отзывов и высоким
                                рейтингом.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2018/2018-duo-2-2.png"
                              srcSet="img/three/2018/2018-duo-2-2@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__note desktop">
                            <div className="item__note-text">
                              <p>
                                Согласно исследованиям, в 90% случаев решение об
                                онлайн-покупке клиент принимает с использованием
                                отзывов и склонен доверять продавцу с большим
                                количеством положительных отзывов и высоким
                                рейтингом.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-trapeze-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2018-11">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Ноябрь</div>
                        <h2 className="item__title">Продавцы спят спокойнее</h2>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2022 item__solo-2018-text item__solo-2018-text-2 mobile">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          В объявлениях категорий «Авто» и «Недвижимость» номера
                          частных продавцов заменены на подменные. Это позволило
                          защитить пользователей от спамеров и систем, которые
                          собирают номера для продажи. Новая функция никак не
                          мешает покупателю связываться с продавцом: после
                          первого звонка система запоминает связку и после
                          замены временного номера в объявлении продолжает
                          направлять звонки нужному абоненту. В 2022 году
                          виртуальные подменные номера распространили на всех
                          продавцов во всех категориях.
                        </p>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-trapeze-green.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__duo item__duo-2018-3">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text desktop">
                            <p>
                              В объявлениях категорий «Авто» и «Недвижимость»
                              номера частных продавцов заменены на подменные.
                              Это позволило защитить пользователей от спамеров и
                              систем, которые собирают номера для продажи. Новая
                              функция никак не мешает покупателю связываться с
                              продавцом: после первого звонка система запоминает
                              связку и после замены временного номера в
                              объявлении продолжает направлять звонки нужному
                              абоненту. В 2022 году виртуальные подменные номера
                              распространили на всех продавцов во всех
                              категориях.
                            </p>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2018/2018-duo-3.png"
                              srcSet="img/three/2018/2018-duo-3@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>
                                Число активных объявлений на Авито превысило
                              </p>
                            </div>
                            <div className="item__note-title">
                              <p>50 млн.</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1 desktop">
                          <img
                            src="img/three/figure-trapeze-green.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-hexagon-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* 2019 */}

                <section
                  className="item item--anim item__year item__year-2019"
                  id="y2019"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2019</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-hexagon-blue.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img src="img/three/figure-semicircle-red.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2019-01">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Январь</div>
                        <h2 className="item__title">
                          «Бесконечный поток» привлекает пользователей
                        </h2>
                        <div className="item__text">
                          «Авито» запускает бесконечную рекомендательную ленту —
                          одну из самых популярных функций по сей день.
                          «Бесконечный поток» помогает формировать устойчивую
                          привычку использования сервиса — пользователей
                          становится больше.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-hexagon-blue.svg" alt="" />
                        </div>

                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__trio item__trio-2019-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left"></div>
                        <div className="item__center">
                          <div className="item__img">
                            <img
                              src="img/three/2019/2019-trio-1.png"
                              srcSet="img/three/2019/2019-trio-1@2x.png 2x"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="item__right">
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>Naspers увеличивает долю в «Авито» до</p>
                            </div>
                            <div className="item__note-title">
                              <p>99,6%</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2019-05">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Май</div>
                        <h2 className="item__title">
                          Офис «Авито Тех» получает премию Best Office Awards
                        </h2>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-hexagon-violet.svg"
                            alt=""
                          />
                        </div>

                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-green.svg"
                            alt=""
                          />
                        </div>

                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-trapeze-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__img item__img-2019-05 item__img-2019-05-1">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2019/2019-img-1.png"
                        srcSet="img/three/2019/2019-img-1@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2019-05 item__img-2019-05-2">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2019/2019-img-2.png"
                        srcSet="img/three/2019/2019-img-2@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2019-05 item__img-2019-05-3">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2019/2019-img-3.png"
                        srcSet="img/three/2019/2019-img-3@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2019-05 item__img-2019-05-4">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2019/2019-img-4.png"
                        srcSet="img/three/2019/2019-img-4@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2019-05 item__img-2019-05-5">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2019/2019-img-5.png"
                        srcSet="img/three/2019/2019-img-5@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2019-06">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Июнь</div>
                        <h2 className="item__title">
                          19 877 населенных пунктов доставки
                        </h2>
                        <div className="item__text">
                          «Авито» и «Почта России» начали тестировать сервис
                          доставки в почтовые отделения предоплаченных товаров,
                          приобретенных через сайт. Сначала пилот стартовал в
                          Твери, позже — в 7 крупных городах, Московской и
                          Ленинградской областях. Это позволило расширить радиус
                          «Авито Доставки» до 19 877 населенных пунктов.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-ticket-green.svg" alt="" />
                        </div>

                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__trio item__trio-2019-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>
                                По итогам 2019 года Авито заплатил в бюджет РФ
                                налогов на
                              </p>
                            </div>
                            <div className="item__note-title">
                              <p>8 млрд руб.</p>
                            </div>
                          </div>
                        </div>
                        <div className="item__center">
                          <div className="item__img">
                            {/* <img
                      src="img/three/2019/2019-trio-2.png"
                      srcSet="img/three/2019/2019-trio-2@2x.png 2x"
                      alt=""
                    /> */}
                            <picture>
                              <source
                                src="img/three/2019/2019-trio-2.png"
                                srcSet="img/three/2019/2019-trio-2@2x.png 2x"
                                alt=""
                                media="(min-width: 768px)"
                              />
                              <img
                                src="img/three/2019/2019-trio-2-m.png"
                                srcSet="img/three/2019/2019-trio-2-m@2x.png 2x"
                                alt=""
                                media="(max-width: 767.9px)"
                              />
                            </picture>
                          </div>
                        </div>
                        <div className="item__right">
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>
                                Количество штатных сотрудников приближается к
                              </p>
                            </div>
                            <div className="item__note-title">
                              <p>2 тысячам человек</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* <Footer /> */}

                {/* 2020 */}

                <section
                  className="item item--anim item__year item__year-2020"
                  id="y2020"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2020</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-semicircle-red.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img src="img/three/figure-pill-blue.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-3">
                        <img src="img/three/figure-diamond-violet.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2020-03">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Март</div>
                        <h2 className="item__title">Онлайн-показы квартир</h2>
                        <div className="item__text">
                          В связи с пандемией «Авито» запустил ряд онлайн-услуг.
                          Например, онлайн-показы квартир в период самоизоляции
                          и юридическую проверку квартир за символический 1
                          рубль.
                        </div>
                        <div className="item__img">
                          <img
                            src="img/three/2020/2020-month-03-img.png"
                            srcSet="img/three/2020/2020-month-03-img@2x.png 2x"
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-diamond-violet.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-pill-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__trio item__trio-2020-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__note desktop">
                            <div className="item__note-text">
                              <p>
                                «Авито» покупает 51% российского сервиса для
                                автодилеров MaxPoster.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="item__center">
                          <div className="item__img">
                            {/* <img
                      src="img/three/2020/2020-duo-1.png"
                      srcSet="img/three/2020/2020-duo-1@2x.png 2x"
                      alt=""
                    /> */}

                            <picture>
                              <source
                                src="img/three/2020/2020-duo-1.png"
                                srcSet="img/three/2020/2020-duo-1@2x.png 2x"
                                alt=""
                                media="(min-width: 768px)"
                              />
                              <img
                                src="img/three/2020/2020-duo-1-m.png"
                                srcSet="img/three/2020/2020-duo-1-m@2x.png 2x"
                                alt=""
                                media="(max-width: 767.9px)"
                              />
                            </picture>
                          </div>
                        </div>
                        <div className="item__right">
                          <div className="item__text">
                            <p>
                              Каждая вторая квартира в стране продается на
                              «Авито Недвижимости».
                            </p>
                          </div>
                          <div className="item__note mobile">
                            <div className="item__note-text">
                              <p>
                                «Авито» покупает 51% российского сервиса для
                                автодилеров MaxPoster.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-green.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2020-03-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Март</div>
                        <h2 className="item__title">
                          Безопасный онлайн-шоппинг
                        </h2>
                        <div className="item__text">
                          В СМИ стартует масштабная образовательная кампания по
                          безопасному онлайн-шопингу и марафон по цифровой
                          грамотности в соцсетях. 150 публикаций охватывают 31,6
                          млн человек.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-hexagon-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-rhombus-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__solo item__solo-2020 item__solo-2020-img item__solo-2020-img-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__image">
                          {/* <img
                    src="img/three/2020/2020-solo-1.png"
                    srcSet="img/three/2020/2020-solo-1@2x.png 2x"
                    alt=""
                  /> */}
                          <picture>
                            <source
                              src="img/three/2020/2020-solo-1.png"
                              srcSet="img/three/2020/2020-solo-1@2x.png 2x"
                              alt=""
                              media="(min-width: 768px)"
                            />
                            <img
                              src="img/three/2020/2020-solo-1-m.png"
                              srcSet="img/three/2020/2020-solo-1-m@2x.png 2x"
                              alt=""
                              media="(max-width: 767.9px)"
                            />
                          </picture>
                        </div>

                        <div className="item__text">
                          <p>
                            «Авито» — самое скачиваемое приложение в России.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2020-06">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Июнь</div>
                        <h2 className="item__title">
                          Доставка товаров в отделения «Почты России» заработала
                          по всей стране
                        </h2>
                      </div>
                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-hexagon-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2020 item__solo-2020-img item__solo-2020-img-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        <img
                          src="img/three/2020/2020-solo-2.png"
                          srcSet="img/three/2020/2020-solo-2@2x.png 2x"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2018 item__solo-2020-text item__solo-2020-text-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          Перепродажа товаров на «Авито» за 2020 год позволила
                          сократить выбросы парниковых газов на
                        </p>
                        <span>18 млн тонн</span>
                        <p>
                          Это больше, чем способны потребить все леса Карелии.
                        </p>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-blue.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* 2021 */}

                <section
                  className="item item--anim item__year item__year-2021"
                  id="y2021"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2021</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-triangle-green.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img
                          src="img/three/figure-semicircle-violet.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show  item__month item__month-2021-01">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Январь</div>
                        <h2 className="item__title">
                          500 чат-ботов после пандемии
                        </h2>
                        <div className="item__text">
                          После массового перехода на удаленку «Авито» всерьез
                          взялся за автоматизацию: сервис должен был стать как
                          можно более комфортным для пользователя. Теперь 96%
                          обращений обрабатывает робот, а оставшиеся 4% —
                          сотрудники клиентского сервиса.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-triangle-green.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__duo item__duo-2021-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text">
                            <p>
                              После массового перехода на удаленку «Авито»
                              инвестирует $1,2 млн в чат-бот для подбора
                              персонала HR Messenger — одного из главных игроков
                              HR-Tech рынка России и СНГ. Бот автоматизирует
                              процесс подбора резюме и даже проводит первичное
                              тестирование. К концу года по разным направлениям
                              в «Авито» работают 500 чат-ботов.
                            </p>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            {/* <img
                      src="img/three/2021/2021-duo-1.png"
                      srcSet="img/three/2021/2021-duo-1@2x.png 2x"
                      alt=""
                    /> */}

                            <img src="img/three/2021-duo-1-m-1.gif" alt="" />
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2021 item__solo-2021-img item__solo-2021-img-3 mobile">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        <img src="img/three/2021/2021-duo-1-m-1.gif" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2021-01-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Январь</div>
                        <h2 className="item__title">
                          Из доски объявлений — в маркетплейс
                        </h2>
                        <div className="item__text">
                          Площадка превращается в товарный маркетплейс:
                          становится посредником между продавцом и покупателем,
                          давая гарантии обеим сторонам и упрощая сделку.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-hexagon-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__solo item__solo-2021 item__solo-2021-img item__solo-2021-img-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__image">
                          {/* <img
                    src="img/three/2021/2021-solo-1.png"
                    srcSet="img/three/2021/2021-solo-1@2x.png 2x"
                    alt=""
                  /> */}
                          <picture>
                            <source
                              src="img/three/2021/2021-solo-1.png"
                              srcSet="img/three/2021/2021-solo-1@2x.png 2x"
                              alt=""
                              media="(min-width: 768px)"
                            />
                            <img
                              src="img/three/2021/2021-solo-1-m.png"
                              srcSet="img/three/2021/2021-solo-1-m@2x.png 2x"
                              alt=""
                              media="(max-width: 767.9px)"
                            />
                          </picture>
                        </div>

                        <div className="item__text">
                          <p>
                            А в отзывах теперь видны реальные профили
                            покупателей.
                          </p>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-ticket-green.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2021 item__solo-2021-text item__solo-2021-text-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          Раздел «Автозапчасти» «переехал» из категории «Авто» в
                          «Товары» — и теперь для них стала доступна доставка по
                          всей России. «Автозапчасти» — один из самых больших
                          разделов по числу объявлений, на него приходится почти
                          четверть всех объявлений на «Авито».
                        </p>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-diamond-violet.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-trapeze-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item  item__solo item__solo-2021 item__solo-2021-img item__solo-2021-img-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        {/* <img
                    src="img/three/2021/2021-duo-2-1.png"
                    srcSet="img/three/2021/2021-duo-2-1@2x.png 2x"
                    alt=""
                  /> */}

                        <iframe
                          width={window.screen.width > 767 ? "844" : "335"}
                          height={window.screen.width > 767 ? "449" : "200"}
                          src="https://www.youtube.com/embed/C3gjkIyn8NI"
                          srcDoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/C3gjkIyn8NI?mute=1&autoplay=1><img src=img/three/2021/2021-duo-2-1.png alt='img'> <div style='display: block;position: absolute;left: calc(50% - 28px) ;top: calc(50% - 28px);width: 56px;height: 56px;'>
                                      <img src='img/three/play-button.svg' alt='' /></div></a>"
                          frameBorder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                          title=""
                        ></iframe>

                        {/* <div className="item__play">
                    <img src="img/three/play-button.svg" alt="" />
                  </div>

                  <div className="item__pause">
                    <img src="img/three/play-button.svg" alt="" />
                  </div> */}
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim  item__solo item__solo-2021 item__solo-2021-text item__solo-2021-text-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          «Авито» обходит старейший сайт объявлений в мире —
                          американский Craiglist — и становится самой посещаемой
                          платформой объявлений в мире.
                        </p>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-violet.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-trapeze-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2021-09">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Сентябрь</div>
                        <h2 className="item__title">
                          Ты мне доставляешь, значит я получу
                        </h2>
                        <div className="item__text">
                          Количество заказов с «Авито Доставкой» увеличивается в
                          2,3 раза.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-rhombus-green.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__duo item__duo-2021-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left desktop">
                          <div className="item__img">
                            <img
                              src="img/three/2021/2021-duo-2-1.png"
                              srcSet="img/three/2021/2021-duo-2-1@2x.png 2x"
                              alt=""
                            />
                            {/* <iframe
                    width="378" 
                    height="219" 
                    src="https://www.youtube.com/embed/C3gjkIyn8NI"
                    srcDoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/C3gjkIyn8NI?autoplay=1><img src=img/three/2021/2021-duo-2-1.png alt='img'> <div style='display: block;position: absolute;left: calc(50% - 28px) ;top: calc(50% - 28px);width: 56px;height: 56px;'>
                                      <img src='img/three/play-button.svg' alt='' /></div></a>"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    title=""
                ></iframe> */}
                            {/* <div className="item__play">
                      <img src="img/three/play-button.svg" alt="" />
                    </div> */}

                            {/* <div className="item__pause">
                      <img src="img/three/play-button.svg" alt="" />
                    </div> */}
                          </div>
                          <div className="item__text">
                            <p>
                              Компания запустила рекламную кампанию с Клавой
                              Кокой: совместно с Black Star она записала песню
                              «Ты мне доставляешь, значит я получу», получившую
                              миллиарды просмотров в TikTok.
                            </p>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2021/2021-duo-2-2.png"
                              srcSet="img/three/2021/2021-duo-2-2@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__text mobile">
                            <p>
                              Компания запустила рекламную кампанию с Клавой
                              Кокой: совместно с Black Star она записала песню
                              «Ты мне доставляешь, значит я получу», получившую
                              миллиарды просмотров в TikTok.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2021-12">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Декабрь</div>
                        <h2 className="item__title">
                          Уникальных пользователей «Авито» больше, чем половина
                          всей аудитории Рунета
                        </h2>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__duo item__duo-2021-3">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left">
                          <div className="item__text">
                            <p>
                              20 млн человек разместили объявления на «Авито» к
                              концу 2021 года. Количество уникальных
                              пользователей в месяц — 50 млн человек, это больше
                              половины всей аудитории Рунета.
                            </p>
                            <p>
                              «Авито» становится самым большим классифайдом в
                              мире в категории Sopping. В штате компании — 3,8
                              тыс. человек.
                            </p>
                          </div>

                          <div className="item__note mobile">
                            <div className="item__note-text">
                              <p>
                                MaxPoster переходит под полный контроль «Авито».
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="item__right">
                          <div className="item__img">
                            <img
                              src="img/three/2021/2021-duo-3.png"
                              srcSet="img/three/2021/2021-duo-3@2x.png 2x"
                              alt=""
                            />
                          </div>
                          <div className="item__note desktop">
                            <div className="item__note-text">
                              <p>
                                MaxPoster переходит под полный контроль «Авито».
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* 2022 */}

                <section
                  className="item item--anim item__year item__year-2022"
                  id="y2022"
                >
                  <div className="item__wrapper">
                    <div className="item__title">2022</div>
                    <div className="item__text"></div>
                    <div className="item__figures">
                      <div className="item__figure item__figure-1">
                        <img src="img/three/figure-trapeze-violet.svg" alt="" />
                      </div>

                      <div className="item__figure item__figure-2">
                        <img src="img/three/figure-pill-green.svg" alt="" />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2022-10">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Октябрь</div>
                        <h3 className="item__title">Битва за «Авито»</h3>
                        <div className="item__text">
                          Весной 2022 года владелец «Авито», южноафриканская
                          Naspers выставила пакет акций компании на продажу. В
                          марте «Авито» отделился от бизнеса OLX Group (дочерний
                          холдинг Naspers) и заработал как самостоятельная
                          компания. По данным СМИ, желающих приобрести одну из
                          крупнейших и самых прибыльных компаний Рунета
                          насчитывался не один десяток.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-trapeze-violet.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-green.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2022 item__solo-2022-img item__solo-2022-img-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        {/* <img
                    src="img/three/2022/2022-solo-1.png"
                    srcSet="img/three/2022/2022-solo-1@2x.png 2x"
                    alt=""
                  /> */}

                        <picture>
                          <source
                            src="img/three/2022/2022-solo-1.png"
                            srcSet="img/three/2022/2022-solo-1@2x.png 2x"
                            alt=""
                            media="(min-width: 768px)"
                          />
                          <img
                            src="img/three/2022/2022-solo-1-m.png"
                            srcSet="img/three/2022/2022-solo-1-m@2x.png 2x"
                            alt=""
                            media="(max-width: 767.9px)"
                          />
                        </picture>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item__solo item__solo-2022 item__solo-2022-text item__solo-2022-text-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__text">
                        <p>
                          100% акций «Авито» покупает холдинг Kismet Capital
                          Group российского бизнесмена Ивана Таврина. Таврин —
                          бывший член совета директоров Mail.ru Group, инвестор
                          Ozon.ru, «Циана» и HeadHunter.
                        </p>
                        <p>Сумма сделки</p>
                        <span>151 млрд руб. ($2,4 млрд)</span>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-blue.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2022-10-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Октябрь</div>
                        <h3 className="item__title">Внешнее обновление</h3>
                        <div className="item__text">
                          15-летие «Авито» отметил обновлением дизайн-системы. В
                          основе обновления (им занималось бюро «Щука») миссия
                          «Авито»: «помочь каждому улучшить собственную жизнь и
                          жизнь людей вокруг». Новая дизайн-система освежила
                          бренд, сохранив графическое наследие. Новый знак и
                          надписи делают образ бренда надёжнее, цветовые решения
                          — радостнее, графику — пластичнее, а композиционные и
                          типографические принципы — яснее.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-pill-red.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-hexagon-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2022 item__solo-2022-img item__solo-2022-img-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        {/* <img
                    src="img/three/2022/2022-solo-2.png"
                    srcSet="img/three/2022/2022-solo-2@2x.png 2x"
                    alt=""
                  /> */}

                        <picture>
                          <source
                            src="img/three/2022/2022-solo-2.png"
                            srcSet="img/three/2022/2022-solo-2@2x.png 2x"
                            alt=""
                            media="(min-width: 768px)"
                          />
                          <img
                            src="img/three/2022/2022-solo-2-m.png"
                            srcSet="img/three/2022/2022-solo-2-m@2x.png 2x"
                            alt=""
                            media="(max-width: 767.9px)"
                          />
                        </picture>
                      </div>

                      {/* <div className="item__figures desktop">
                  <div className="item__figure item__figure-1">
                    <img src="img/three/figure-rhombus-blue.svg" alt="" />
                  </div>
                </div> */}
                    </div>
                  </div>
                </section>

                <section className="item item--anim  item--anim-show item__month item__month-2022-10-3">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Октябрь</div>
                        <h3 className="item__title">
                          Из классифайда в IT-компанию
                        </h3>
                        <div className="item__text">
                          «Авито» пережил серьезную трансформацию и из
                          крупнейшего в мире классифайда превратился в
                          IT-компанию. В «Авито» работают около 2000
                          IT-специалистов, которые трудятся над актуальными
                          изменениями на сайте и в приложении, над безопасностью
                          платформы и комфортом пользователя.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-trapeze-green.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-semicircle-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2022-11">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Ноябрь</div>
                        <h3 className="item__title">
                          «Авито» становится партнером поисково-спасательного
                          отряда «ЛизаАлерт»
                        </h3>
                        <div className="item__text">
                          «Авито» объединил усилия с «ЛизаАлерт». Цель —
                          просвещение населения в сфере онлайн- и
                          офлайн-безопасности, а также поддержка потребностей
                          поискового отряда.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-hexagon-violet.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-ticket-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-01 item__img-2022-01-1">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-1-1.png"
                        srcSet="img/three/2022/2022-img-1-1@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-01 item__img-2022-01-2">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-1-2.png"
                        srcSet="img/three/2022/2022-img-1-2@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__solo item__solo-2022 item__solo-2022-img item__solo-2022-img-3 item__solo-2022-img-3-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__text">
                          <p>
                            На VIII Межрегиональном форуме добровольческого
                            поисково-спасательного отряда «ЛизаАлерт» Авито
                            представил интерактивную карту: пользователи Авито
                            смогут видеть, какие поиски проходят в настоящий
                            момент рядом с ними и в какой помощи нуждаются
                            добровольцы. Карта интегрирована в специальный
                            раздел на сайте «Авито» , там же — опции поиска
                            проживания для добровольцев и сбор средств на
                            оборудование.
                          </p>
                        </div>

                        <div className="item__image">
                          <img
                            src="img/three/2022/2022-solo-3.png"
                            srcSet="img/three/2022/2022-solo-3@2x.png 2x"
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-rhombus-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2022-11-2">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Ноябрь</div>
                        <h3 className="item__title">Корзина покупателей</h3>
                        <div className="item__text">
                          Запускается единая корзина покупателя: за товары
                          разных продавцов можно платить единым платежом, как в
                          классических интернет-магазинах.
                        </div>
                        <div className="item__img">
                          <img
                            src="img/three/2022/2022-11-img.png"
                            srcSet="img/three/2022/2022-11-img@2x.png 2x"
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img src="img/three/figure-pill-blue.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__trio item__trio-2022-1">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner">
                        <div className="item__left desktop">
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>Число объявлений впервые превысило</p>
                            </div>
                            <div className="item__note-title">
                              <p>135 млн</p>
                            </div>
                          </div>
                        </div>
                        <div className="item__center">
                          <div className="item__img">
                            <img
                              src="img/three/2022/2022-11-img.png"
                              srcSet="img/three/2022/2022-11-img@2x.png 2x"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="item__right">
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>Число объявлений впервые превысило</p>
                            </div>
                            <div className="item__note-title">
                              <p>135 млн</p>
                            </div>
                          </div>
                          <div className="item__note">
                            <div className="item__note-text">
                              <p>Месячная аудитория составляет почти</p>
                            </div>
                            <div className="item__note-title">
                              <p>60 млн человек</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img
                            src="img/three/figure-semicircle-red.svg"
                            alt=""
                          />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-diamond-violet.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item--anim item--anim-show item__month item__month-2022-11-3">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__inner item__inner--fd">
                        <div className="item__caption">Ноябрь</div>
                        <h3 className="item__title">Новая точка — в Казани</h3>
                        <div className="item__text">
                          «Авито» открыл Центр клиентского сервиса в Казани.
                          Офис рассчитан на 220 комфортных рабочих мест: около
                          20 из них — для ИТ-специалистов департамента
                          разработки «Авито Тех», 200 — для специалистов
                          клиентского сервиса.
                        </div>
                      </div>

                      <div className="item__figures">
                        <div className="item__figure item__figure-1">
                          <img src="img/three/figure-pill-blue.svg" alt="" />
                        </div>
                        <div className="item__figure item__figure-2">
                          <img
                            src="img/three/figure-triangle-green.svg"
                            alt=""
                          />
                        </div>

                        <div className="item__figure item__figure-3">
                          <img src="img/three/figure-triangle-red.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-1">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-1.png"
                        srcSet="img/three/2022/2022-img-2-1@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-2">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-2.png"
                        srcSet="img/three/2022/2022-img-2-2@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-3">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-3.png"
                        srcSet="img/three/2022/2022-img-2-3@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>
                <section className="item item__img item__img-2022-02 item__img-2022-02-6">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-6.png"
                        srcSet="img/three/2022/2022-img-2-6@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-4">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-4.png"
                        srcSet="img/three/2022/2022-img-2-4@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-5">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-5.png"
                        srcSet="img/three/2022/2022-img-2-5@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__img item__img-2022-02 item__img-2022-02-7">
                  <div className="item__wrapper">
                    <div className="item__image">
                      <img
                        src="img/three/2022/2022-img-2-7.png"
                        srcSet="img/three/2022/2022-img-2-7@2x.png 2x"
                        alt=""
                      />
                    </div>
                  </div>
                </section>

                <section className="item item__solo item__solo-2022 item__solo-2022-img item__solo-2022-img-3 _92">
                  <div className="item__container">
                    <div className="item__wrapper">
                      <div className="item__image">
                        <img
                          src="img/three/2022/2022-solo-4.png"
                          srcSet="img/three/2022/2022-solo-4@2x.png 2x"
                          alt=""
                        />
                        <div className="item__play">
                          <img src="img/three/play-button.svg" alt="" />
                        </div>

                        <div className="item__pause">
                          <img src="img/three/play-button.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <Footer components="three" />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Three;
